export default __webpack_public_path__ + "static/media/belt_wallet.a8567445.jpg";